import {
  AutoLinkPlugin as LexicalAutoLinkPlugin,
  createLinkMatcherWithRegExp,
} from '@lexical/react/LexicalAutoLinkPlugin';
import { toLinkUrl, URL_REGEX } from './link-url.ts';

const matchers = [createLinkMatcherWithRegExp(URL_REGEX, toLinkUrl)];

export const AutoLinkPlugin = () => {
  return <LexicalAutoLinkPlugin matchers={matchers} />;
};
